<template>
  <div class="vg_wrapper">
    <el-tabs v-model="activeName" type="border-card">
      <el-tab-pane label="单据信息" name="first" :key="'first'">
        <childTab1 @isShow="isShow" ref="childTab1" />
      </el-tab-pane>
      <el-tab-pane label="审批流转" name="second" :key="'second'" :lazy="true">
        <childTab3 :is-show="isSho" />
      </el-tab-pane>
      <el-tab-pane label="相关文档" name="third" :key="'third'">
        <childTab2 />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import MtrlEditMain from '@/views/DevelopManagement/MtrlManage/TabChild/MtrlEditMain';
import MtrlEditAbout from '@/views/DevelopManagement/MtrlManage/TabChild/MtrlEditAbout';
import MtrlEditAppr from '@/views/DevelopManagement/MtrlManage/TabChild/MtrlEditAppr.vue';

export default {
  name: 'MtrlEdit',
  components: {
    childTab1: MtrlEditMain,
    childTab2: MtrlEditAbout,
    childTab3: MtrlEditAppr
  },
  data() {
    return {
      activeName: 'first',
      isSho: true
    };
  },
  created() {},
  methods: {
    isShow(val) {
      this.isSho = val;
    },
    draftState() {
      this.$refs.childTab1.initData();
    }
  }
};
</script>

<style scoped lang="scss"></style>
